import React from "react";
import "./Bespock_gift.css";
import Heading_banner_section from "../common_components/heading_banner/Heading_banner_section";
import Bespock_gift_step_form from "./bespock_gift_step_form/Bespock_gift_step_form";
import How_Bespoke_Gifting_Works from "./how_Bespoke_Gifting_Works/How_Bespoke_Gifting_Works";
// import Your_Idea from "../common_components/your_Idea/Your_Idea";
import Our_Craftmenship from "./our-craftmenship/Our_Craftmenship";
function Bespock_gift() {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "BESPOKE GIFTING" },
  ];
  return (
    <>
      <section className="Bespock_gift">
        <Heading_banner_section
          headingText={"BESPOKE GIFTING"}
          subHeadingText={"You may get Bespoke Gifts Hand-Crafted from us"}
          breadcrumbItems={breadcrumbItems}
        />
        {/* <Your_Idea btnText={" Bespoke Gifts"} /> */}
        <Our_Craftmenship />
        <How_Bespoke_Gifting_Works />
        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-12 col-md-12">
              <Bespock_gift_step_form />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Bespock_gift;
